import {
  faTrash,
  faToilet, // Safe, private toilets
  faTruck, // Desludging (Vacuum truck)
  faDumpster, // FS disposal at treatment site
  faWater, // FS treatment capacity
  faRecycle, // Effectiveness of FS/WW treatment
  faRestroom, // Shared toilet facilities (CT/PT)
  faUniversalAccess, // Universal design adherence (CTs)
  faVenus, // Women users (CTs)
  faRoute, // Distance to CT (measured in meters)
  faWheelchair, // PTs adhering to universal design
  faPersonDress, // Women users (PTs)
  faSchool, // Educational institutions (FS/WW treatment)
  faHospital, // Healthcare facilities (FS/WW treatment)
  faBalanceScale, // Ratio of LIC access to total population access
  faUsers, // LIC population with safe toilets
  faHouseUser, // LIC, NSS, IHHL desludging
  faPeopleGroup, // LIC population with FS disposal at treatment plant
  faHandHoldingWater, // PTs safely transporting FS/WW
  faIndustry, // Desludging done mechanically/semi-mechanically
  faMicroscope, // Percentage of tests in compliance
} from "@fortawesome/free-solid-svg-icons";

const iconMapping = {
  "SF-1a": faToilet, // Safe, private toilets
  "SF-1b": faTruck, // Desludging (Vacuum truck)
  "SF-1c": faDumpster, // FS disposal at treatment site
  "SF-1d": faWater, // FS treatment capacity
  "SF-1e": faWater, // FS treatment capacity (collected FS)
  "SF-1f": faRecycle, // Effectiveness of FS/WW treatment
  "SF-1g": faRecycle, // Treatment effectiveness
  "SF-2a": faUsers, // LIC population with safe toilets
  "SF-2b": faHouseUser, // LIC, NSS, IHHL desludging
  "SF-2c": faPeopleGroup, // LIC population with FS disposal at treatment plant
  "SF-3": faRestroom, // Shared toilet facilities (CT/PT)
  "SF-3b": faUniversalAccess, // CTs adhering to universal design
  "SF-3c": faVenus, // Women users (CTs)
  "SF-3e": faRoute, // Distance to CT (meters)
  "SF-4a": faHandHoldingWater, // PTs safely transporting FS/WW
  "SF-4b": faWheelchair, // PTs adhering to universal design
  "SF-4d": faPersonDress, // Women users (PTs)
  "SF-5": faSchool, // Educational institutions (FS/WW treatment)
  "SF-6": faHospital, // Healthcare facilities (FS/WW treatment)
  "SF-7": faIndustry, // Desludging done mechanically/semi-mechanically
  "SF-9": faMicroscope, // Percentage of tests in compliance
  "EQ-1": faBalanceScale, // Ratio of LIC access to total population
};


export const fetchIMISCityData = async (request, setter) => {
  try {
    const response = await request(
      "GET",
      `/v1/imis/indicators/metadata/info`,
      {},
      "external_service"
    );
    setter(response);
    return response;
  } catch (error) {}
};

export const fetchIMISIndicatorsList = async (request, payload, setter) => {
  try {
    const response = await request(
      "GET",
      `/v1/imis/indicators/${payload.city}/${payload.year}`,
      {},
      "external_service"
    );

    setter(groupByOutcome(response.indicators));
  } catch (error) {
    console.log(error);
  }
};

export const fetchIndicatorsList = async (request, payload, setter) => {
  if (!payload.city || !payload.year) {
    setter({});
    return;
  }

  try {
    const response = await request(
      "GET",
      `/v1/city-profile/indicators?location=${payload.city}&year=${payload.year}`,
      {},
      "survey_service"
    );

    // Replace 'indicator' with 'name' in-place
    for (const category in response) {
      response[category] = response[category].map(item => {
        const { indicator, ...rest } = item;
        return { ...rest, name: indicator };
      });
    }

    setter(response);
  } catch (error) {
    console.log(error);
  }
};


function groupByOutcome(data) {
  return data?.reduce((acc, item) => {
    if (!acc[item.outcome]) {
      acc[item.outcome] = [];
    }
    acc[item.outcome].push(transformIndicatorsItem(item));
    return acc;
  }, {});
}
const transformIndicatorsItem = (dataItem) => {
  return {
    icon: iconMapping[dataItem.cwisCode] || faTrash, // Default to faTrash if no match
    name: dataItem.name,
    outcome: dataItem.outcome,
    value: isNaN(parseFloat(dataItem.value)) ? "0" : dataItem.value, // Handle NaN values
    unit: dataItem.unit || " ", // Provide a default unit
    color: "#FFA600", // Assign default color
  };
};
